<template>
    <div class="quarter-bank">
        <el-table :data="MonthsTotalList" stripe border center :size="GCONFIG.styleTableSize" style="margin: 18px 0">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="年度" prop="year"></el-table-column>
            <el-table-column label="季度" prop="quarter"></el-table-column>
            <el-table-column label="月份" prop="month"></el-table-column>
            <el-table-column label="价值目标(万)" prop="value"></el-table-column>
            <!--<el-table-column label="权重%" prop="weight"></el-table-column>-->
            <!--<el-table-column label="Leader确认价值(万)" prop="leaderValue"></el-table-column>-->
            <!--<el-table-column label="Leader确认权重%" prop="leaderWeight"></el-table-column>-->
            <el-table-column label="实际价值(万)" prop="factValue"></el-table-column>
        </el-table>
    </div>
</template>

<script>

    //定义组件
    export default {
        data() {
            return {
                MonthsTotalList:[],
            }
        },
        computed:{

        },
        props:['sectionClassId'],
        //挂载时候执行
        mounted() {
            this.getKpiMonthsTotalList()
        },
        methods: {
            getKpiMonthsTotalList() {
                this.$store.dispatch('getKpiMonthsTotal',{}).then(res=>{
                    console.log(res)
                    this.MonthsTotalList = res
                })
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cooperative/quarterKpiTotal.vue